var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"solution-header ma-0 subtitle2"},[_c('span',{staticClass:"solution-header__title",attrs:{"data-testid":"solution-title"}},[_vm._v("\n    "+_vm._s(_vm.$t('problem_solving.improve.accordion_item_title', {
        rootCauseNumber: this.getRootCauseNumber(),
      }))+"\n  ")]),_c('span',{staticClass:"solution-header__status",class:{
      'solution-header__status--completed': this.status === 'completed',
      'solution-header__status--missing': this.isMissingRootCause,
    },attrs:{"data-testid":"solution-status"}},[_vm._v(_vm._s(this.getStatus()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }